var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ExportNFSeInvoice"),
            visible: _vm.showExportNFSeInvoice,
            width: "700px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportNFSeInvoice = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: { size: "small", "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "orderCenterCont.DownloadTemplate"
                                ),
                              },
                            },
                            [
                              _c("div", { ref: "download1" }, [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.initDown()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#00A551" } },
                                      [
                                        _vm._v(
                                          "导出NFSe模板(Modelo de Exportação NFSe).xlsx"
                                        ),
                                      ]
                                    ),
                                    _c("span", {
                                      staticClass: "el-icon-download",
                                      staticStyle: {
                                        color: "#00A551",
                                        "margin-left": "20px",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.UploadTheFile"),
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "demoUpload",
                                  staticClass: "upload-demo",
                                  attrs: {
                                    "before-upload": _vm.beforeUpload,
                                    "file-list": _vm.fileList,
                                    "http-request": _vm.upLoad,
                                    limit: 1,
                                    "on-exceed": _vm.handleExceed,
                                    "on-remove": _vm.handleRemove,
                                    action: "",
                                    drag: "",
                                    multiple: "",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-plus",
                                    staticStyle: { margin: "50px auto 20px" },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "el-upload__text" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("orderImport.cldrUpload"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-upload__text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "collectionCenter.uploadOnlyXlsx"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-top": "10px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.businessT")))]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                },
                                model: {
                                  value: _vm.businessType,
                                  callback: function ($$v) {
                                    _vm.businessType = $$v
                                  },
                                  expression: "businessType",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "0",
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.expressDelivery"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  key: "1",
                                  attrs: {
                                    label: _vm.$t("collectionCenter.collect"),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showExportNFSeInvoice = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }